export const checkQuizActionsAndAddPhantomAnnotation = (config) => {
    const { annotations } = config; 
    const quizAnnotations = annotations.filter(annotation => annotation.type === "quiz");

    if (!quizAnnotations.length) {
        return config;
    }

    const annotationsWithoutQuizzes = annotations.filter(annotation => annotation.type !== "quiz");
    const newQuizAnnotations = quizAnnotations.map(quiz => {

        const actionsNoPause = quiz.actions.filter((action) => {
            const shouldClearAction = 
                (action.action === 'pause' && action.event === 'atStartTime') || 
                (action.action === "pause" && action.event === 'onActivate');

            return !shouldClearAction;
        })

        quiz.actions = actionsNoPause;
        return quiz;
    })

    let phantomAnnotations = []; 

    newQuizAnnotations.forEach(quiz => {
        let phantom = {
            type: "phantom",
            start: quiz.start,
            end: quiz.end,
            actions: [{"action": "pause", "event": "atStartTime"}],
            target: "player",
            id: `phantom_quiz_${quiz.id}`
        }
        phantomAnnotations.push(phantom);
    })

    return {
        ...config,
        annotations: [
            ...annotationsWithoutQuizzes,
            ...newQuizAnnotations,
            ...phantomAnnotations
        ]
    }
}

